import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useMutation } from '@apollo/client'
import gql from 'graphql-tag'
import { Button, Icon, Label, Popup } from 'semantic-ui-react'

export default function LikeButton({ user, post: { id, likeCount, likes } }) {
    const [liked, setLiked] = useState(false);
    useEffect(() => {
        if (user && likes.find(like => like.username === user.username)) {
            setLiked(true)
        } else {
            setLiked(false)
        }
    }, [user, likes])

    const [likePost] = useMutation(LIKE_POST_MUTATION, {
        variables: { postId: id },
        update(proxy, result) {
            console.log(result)
        },
        onError(err) {
            console.log("ERROR: ", err)
        },


    });

    const likeButton = user ? (
        liked ? (
            <Popup
                content='Unlike post'
                inverted
                trigger={
                    <Button color="teal">
                        <Icon name="heart" />
                    </Button>
                } />
        ) : (
                <Popup
                    content='Like post'
                    inverted
                    trigger={
                        <Button color="teal" basic>
                            <Icon name="heart" />
                        </Button>
                    } />
            )
    ) : (
            <Button as={Link} to="/login" color="teal" basic>
                <Icon name="heart" />
            </Button>
        );

    return (
        <Button as='div' labelPosition='right' onClick={likePost}>
            {likeButton}
            <Label basic color='teal' pointing='left'>
                {likeCount}
            </Label>
        </Button>
    )

}

const LIKE_POST_MUTATION = gql`
mutation likePost($postId:ID!){
    likePost(postId:$postId){
        id
        likes{
            id username
        }
        likeCount
    }
}
`
